"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRID_TYPOGRAPHY_LIST_COL_DEF = void 0;
var _react = _interopRequireDefault(require("react"));
var _Cell = require("../components/Cell");
var _TypographyList = _interopRequireWildcard(require("@gogame/ui/TypographyList"));
var _utils = require("./utils");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var GridTypographyList = function GridTypographyList(_ref) {
  var value = _ref.value,
    colDef = _ref.colDef,
    row = _ref.row,
    rowNode = _ref.rowNode;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var headerName = colDef.headerName,
    getItemValue = colDef.getItemValue,
    getItemTooltip = colDef.getItemTooltip,
    getItemIcon = colDef.getItemIcon,
    _colDef$unitsLabel = colDef.unitsLabel,
    unitsLabelProp = _colDef$unitsLabel === void 0 ? '' : _colDef$unitsLabel,
    limit = colDef.limit,
    placeholder = colDef.placeholder;
  var safePlaceholder = (0, _hooks.useValidPlaceholder)(placeholder, rowNode);
  var unitsLabel = unitsLabelProp;
  if (!unitsLabel && headerName) {
    unitsLabel = (0, _utils.getUnitsNameFromLabel)(headerName);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.ListCellWrapper, {
    align: colDef.align,
    onMouseEnter: function onMouseEnter() {
      return setTouched(true);
    },
    children: value !== null && value !== void 0 && value.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TypographyList["default"], {
      limit: limit,
      divider: ',',
      spacing: 0.5,
      variant: 'body2',
      menuVariant: 'body2',
      unitsLabel: unitsLabel,
      disableMenu: !touched,
      MenuProps: {
        anchorProps: {
          noWrap: true
        }
      },
      children: value.map(function (item, index) {
        var itemTooltip = getItemTooltip === null || getItemTooltip === void 0 ? void 0 : getItemTooltip(item);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TypographyList.TypographyListItem, {
          noWrap: true,
          icon: getItemIcon === null || getItemIcon === void 0 ? void 0 : getItemIcon(item),
          tooltip: itemTooltip,
          disableTooltip: !itemTooltip,
          children: getItemValue(item, colDef, row)
        }, index);
      })
    }) : safePlaceholder
  });
};
var GRID_TYPOGRAPHY_LIST_COL_DEF = exports.GRID_TYPOGRAPHY_LIST_COL_DEF = {
  align: 'left',
  headerAlign: 'left',
  getItemValue: function getItemValue(v) {
    return v === null || v === void 0 ? void 0 : v.name;
  },
  placeholder: '-',
  limit: 2,
  renderCell: function renderCell(_ref2) {
    var value = _ref2.value,
      colDef = _ref2.colDef,
      row = _ref2.row,
      rowNode = _ref2.rowNode;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(GridTypographyList, {
      value: value,
      colDef: colDef,
      row: row,
      rowNode: rowNode
    });
  }
};